import axios from 'axios'

export type AnalyticsSection = 'overview' | 'pages' | 'users' | 'features' | 'performance' | 'realtime'

export interface AnalyticsFilters {
  from: string
  to: string
  user_guid?: string
  path?: string
  company_guid?: string
}

const cleanParams = (filters: AnalyticsFilters) =>
  Object.entries(filters).reduce<Record<string, string>>((params, [key, value]) => {
    if (value) params[key] = value
    return params
  }, {})

export const getAnalyticsSection = async (section: AnalyticsSection, filters: AnalyticsFilters) => {
  const response = await axios.get(`/analytics/${section}`, {params: cleanParams(filters)})
  return response.data
}

export const getAnalyticsFilters = async (companyGuid?: string) => {
  const response = await axios.get('/analytics/filters', {
    params: companyGuid ? {company_guid: companyGuid} : undefined,
  })
  return response.data
}
